import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {GlobalLoaderService} from '../../services/global-loader.service';
import {ApiAgentService} from '../../services/api-agent.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {CommonModule, DecimalPipe} from '@angular/common';
import {MyBusiness} from '../../models/my-business';
import {lastValueFrom} from 'rxjs';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {VatCertificates} from '../../models/vat-certificates';
import {RouterModule} from '@angular/router';

declare var $: any;
declare var ApexCharts: any;
declare var Snackbar: any;

@Component({
  selector: 'app-balance',
  templateUrl: './balance.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule],
  styleUrls: ['./balance.component.scss']
})
export class BalanceComponent implements OnInit {
  private sales: any;
  private subscriptions: any;
  private withdraws: any;
  myBusiness: MyBusiness;
  loading: any;
  vatCerts: VatCertificates[];

  pdfDownloadSubmitted: boolean;
  excelDownloadSubmitted: boolean;

  submittingPdfDownload: boolean;
  submittingExcelDownload: boolean;

  pdfDownloadForm: FormGroup;
  excelDownloadForm: FormGroup;

  @ViewChild('pdfDownloadModal') pdfDownloadModal: ElementRef;
  @ViewChild('excelDownloadModal') excelDownloadModal: ElementRef;

  constructor(private loader: GlobalLoaderService,
              private api: ApiAgentService,
              private formBuilder: FormBuilder,
              private _decimalPipe: DecimalPipe,
              private translate: TranslateService) {
  }

  async submitExcelDownloadForm() {
    this.excelDownloadSubmitted = true;
    if (this.excelDownloadForm.valid) {
      this.submittingExcelDownload = true;
      try {
        let year = this.ev['year'];
        let month = this.ev['month'];
        const timestamp = Date.now();
        let response = await this.api.getExcelReport(year, month, timestamp);
        // debugger;
        if (response) {
          // Check if the response is binary data (CSV or Excel file)
          const blob = new Blob(['\ufeff', response], {type: 'text/csv;charset=utf-8;'});  // Make sure the MIME type matches
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'report_' + (year === '' ? 'all' : year) + '_' + (month === '' ? 'all' : month) + '_' + timestamp + '.csv'; // You can dynamically set the file name if needed
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          this.showToast('');
        }
      } catch (ex) {
        if (ex.error.title) {
          this.showToast(await lastValueFrom(this.translate.get(ex.error.title)));
        } else {
          console.error(ex);
        }
      } finally {
        this.submittingExcelDownload = false;
        this.excelDownloadSubmitted = false;
      }
    }
  }


  async submitPdfDownloadForm() {
    this.pdfDownloadSubmitted = true;
    if (this.pdfDownloadForm.valid) {
      this.submittingPdfDownload = true;
      try {
        let response = await this.api.postPdfVatReport(this.v['year'], this.v['month'], this.v['vatCertId']);
        console.log('response', response);
        window.open(response.url);
      } catch (ex) {
        if (ex.error.title) {
          this.showToast(await lastValueFrom(this.translate.get(ex.error.title)));
        } else {
          this.showToast(await lastValueFrom(this.translate.get('Could not save my setting. Try again')));
        }
      } finally {
        this.submittingPdfDownload = false;
        this.pdfDownloadSubmitted = false;
      }
    }
  }

  private showToast(msg) {
    if (Snackbar) {
      Snackbar.show({
        text: msg,
        pos: 'bottom-center'
      });
    } else {
      alert(msg);
    }
  }

  async ngOnInit() {
    this.loading = true;
    setTimeout(async () => {
      await this.loadResources();
      await this.loadData();
    }, 1000);

    this.pdfDownloadForm = this.formBuilder.group({
      year: ['', Validators.required],
      month: ['', Validators.required],
      vatCertId: ['']
    });

    let year = new Date().getFullYear();
    this.excelDownloadForm = this.formBuilder.group({
      year: [``],
      month: [''],
    });
  }

  // @ts-ignore
  get f() {
    return this.pdfDownloadForm.controls;
  }

  // @ts-ignore
  get e() {
    return this.excelDownloadForm.controls;
  }

  // @ts-ignore
  get v() {
    return this.pdfDownloadForm.value;
  }

  // @ts-ignore
  get ev() {
    return this.excelDownloadForm.value;
  }

  async requested() {
    $('#withdrawModal').modal('hide');
    setTimeout(() => {
      window.location.reload();
    }, 3000);
  }

  private async loadData() {
    this.loading = true;
    this.myBusiness = await this.api.getMyBusiness(true);
    if (this.myBusiness.walletAmount == null) {
      this.myBusiness.walletAmount = 0;
    }
    let transactions = await this.api.getMyWalletTransactions();
    // get sales.
    this.sales = transactions.filter((item) => item.type == 'MERCHANT_WALLET')
      .sort((a, b) => {
        return <any> new Date(b.date) - <any> new Date(a.date);
      });

    // get subscriptions.
    this.subscriptions = transactions.filter((item) => item.type == 'SUB_ACCOUNT_FEES' || item.type == 'SUB_ACCOUNT_FEES_VAT' ||
      item.type == 'SETUP_FEES' || item.type == 'SUBSCRIPTION_FEES' || item.type == 'SETUP_FEES_VAT' || item.type == 'SUBSCRIPTION_FEES_VAT')
      .map((item) => {
        item.amount = item.amount * -1;
        return item;
      })
      .sort((a, b) => {
        return <any> new Date(b.date) - <any> new Date(a.date);
      });

    // get withdraws.
    this.withdraws = transactions.filter((item) => item.type == 'Withdraw').sort((a, b) => {
      return <any> new Date(b.date) - <any> new Date(a.date);
    });

    for (let i = 0; i < this.withdraws.length; i++) {
      let w = this.withdraws[i];
      if (w.amount == 0) {
        this.withdraws[i].isTransferred = false;
      }
    }
    //
    await this.loadTable();
    await this.loadSalesChart();
    // this.vatCerts = await this.api.loadVatCertificates();
    this.vatCerts = await this.api.loadVatCertificates();

    this.loading = false;
  }

  // private async callServer(data, callback, settings) {
  //   let myWalletSales = await this.api.getMyWalletSales(null, 0, 10);
  //   callback({
  //     data: myWalletSales.transactions,
  //   });
  // }

  private async loadTable() {
    let invoiceUrl = this.myBusiness.paymentServerUrl + '/pay/order/';
    let subscription_fees = await lastValueFrom(this.translate.get('Subscription fees'));
    let setup_fees = await lastValueFrom(this.translate.get('Setup fees'));
    let sub_account_fees = await lastValueFrom(this.translate.get('Sub Accounts Fees'));
    let sub_account_fees_vat = await lastValueFrom(this.translate.get('Sub Accounts Fees VAT'));
    let subscription_fees_vat = await lastValueFrom(this.translate.get('Subscription fees VAT'));
    let setup_fees_vat = await lastValueFrom(this.translate.get('Setup fees VAT'));
    let refund = await lastValueFrom(this.translate.get('Refund'));
    let income = await lastValueFrom(this.translate.get('Income'));

    let sar = '<img src="assets/sr.svg" height="18" />'; // await lastValueFrom(this.translate.get('SAR'));
    let sarg = '<img src="assets/srg.svg" height="18" />'; // await lastValueFrom(this.translate.get('SAR'));
    let sarr = '<img src="assets/srr.svg" height="18" />'; // await lastValueFrom(this.translate.get('SAR'));
    let yes = await lastValueFrom(this.translate.get('Yes'));
    let cancelled = await lastValueFrom(this.translate.get('Cancelled'));
    let no = await lastValueFrom(this.translate.get('No'));


    let tableButtons = [
      {extend: 'copy', className: 'btn', text: await lastValueFrom(this.translate.get('Copy'))},
      // {extend: 'excel', className: 'btn', text: await lastValueFrom(this.translate.get('Excel'))},
      {
        className: 'btn',
        text: await lastValueFrom(this.translate.get('Excel')),
        action: () => {
          this.downloadExcelReport();
        }
      },
      {extend: 'print', className: 'btn', text: await lastValueFrom(this.translate.get('Print'))},
      {
        className: 'btn-pdf btn btn-danger',
        text: await lastValueFrom(this.translate.get('Download VAT Report')),
        action: () => {
          this.downloadVatPdf();
        }
      }
    ];

    console.log('vat number', this.myBusiness.vatNumber);
    if (!this.myBusiness.vatNumber) {
      tableButtons.pop();
    }

    $('#sales-extension').DataTable({
      dom: '<"row"<"col-md-12"<"row"<"col-md-6"B><"col-md-6"f> > ><"col-md-12"rt> <"col-md-12"<"row"<"col-md-5"i><"col-md-7"p>>> >',
      buttons: {
        buttons: tableButtons
      },
      'oLanguage': {
        'oPaginate': {
          'sPrevious': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>',
          'sNext': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>'
        },
        'sInfo': await lastValueFrom(this.translate.get('Showing page')) + ' _PAGE_ ' + await lastValueFrom(this.translate.get('of')) + ' _PAGES_',
        'sSearch': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>',
        'sSearchPlaceholder': await lastValueFrom(this.translate.get('Search')) + ' ...',
        'sLengthMenu': 'Results :  _MENU_',
      },
      'stripeClasses': [],
      'pageLength': 10,
      'lengthMenu': [7, 10, 20, 50],
      'data': this.sales,
      'order': [[4, 'desc']],
      'columns': [
        {
          'data': 'identityNumber', 'render': (data) => {
            return '<a target="_blank" href="' + invoiceUrl + data + '">' + data + '</a>';
          }
        },
        {
          'data': 'amount', 'render': (a) => {
            if (a < 0) {
              return '<span class="text-danger">' + this._decimalPipe.transform(a, '1.2-2') + ' ' + sarr + '</span>';
            } else {
              return '<span class="text-success">' + this._decimalPipe.transform(a, '1.2-2') + ' ' + sarg + '</span>';
            }
          }
        },
        {
          'data': 'fees', 'render': (a) => {
            return '<span class="text-danger">' + this._decimalPipe.transform(a, '1.2-2') + ' ' + sarr + '</span>';
          }
        }, {
          'data': 'feesVAT', 'render': (a) => {
            return '<span class="text-danger">' + this._decimalPipe.transform(a, '1.2-2') + ' ' + sarr + '</span>';
          }
        },
        {
          'data': 'note', 'render': (data) => {
            switch (data) {
              case 'Setup fees':
                return setup_fees;
              case 'Subscription fees':
                return subscription_fees;
              case 'Sub Account Fees':
                return sub_account_fees;
              case 'Refund':
                return refund;
              case 'Income' :
                return income;
              default:
                return data;
            }
          }
        },
        {'data': 'clientName'},
        {'data': 'clientMobile'},
        {'data': 'date'},
        {
          'data': 'isTransferred', 'render': (a) => {
            return a == true ? yes : no;
          }
        },
        {'data': 'lastIban'},
        {'data': 'settleDate'}
      ]
    });

    $('#subscriptions-extension').DataTable({
      dom: '<"row"<"col-md-12"<"row"<"col-md-6"B><"col-md-6"f> > ><"col-md-12"rt> <"col-md-12"<"row"<"col-md-5"i><"col-md-7"p>>> >',
      buttons: {
        buttons: [
          {extend: 'copy', className: 'btn', text: await lastValueFrom(this.translate.get('Copy'))},
          {extend: 'excel', className: 'btn', text: await lastValueFrom(this.translate.get('Excel'))},
          {extend: 'print', className: 'btn', text: await lastValueFrom(this.translate.get('Print'))}
        ]
      },
      'oLanguage': {
        'oPaginate': {
          'sPrevious': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>',
          'sNext': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>'
        },
        'sInfo': await lastValueFrom(this.translate.get('Showing page')) + ' _PAGE_ ' + await lastValueFrom(this.translate.get('of')) + ' _PAGES_',
        'sSearch': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>',
        'sSearchPlaceholder': await lastValueFrom(this.translate.get('Search')) + ' ...',
        'sLengthMenu': 'Results :  _MENU_',
      },
      'stripeClasses': [],
      'pageLength': 10,
      'lengthMenu': [7, 10, 20, 50],
      'data': this.subscriptions,
      'columns': [
        {
          'data': 'identityNumber', 'render': (data) => {
            return '<a target="_blank" href="' + invoiceUrl + data + '">' + data + '</a>';
          }
        },
        {
          'data': 'amount', 'render': (a) => {
            if (a < 0) {
              return '<span class="text-danger">' + this._decimalPipe.transform(a, '1.2-2') + ' ' + sar + '</span>';
            } else {
              return '<span class="text-success">' + this._decimalPipe.transform(a, '1.2-2') + ' ' + sar + '</span>';
            }
          }
        },
        {
          'data': 'note', 'render': (data) => {
            switch (data) {
              case 'Setup fees':
                return setup_fees;
              case 'Sub Account Fees':
                return sub_account_fees;
              case 'Setup fees VAT':
                return setup_fees_vat;
              case 'Sub Account Fees VAT':
                return sub_account_fees_vat;
              case 'Subscription fees':
                return subscription_fees;
              case 'Subscription fees VAT':
                return subscription_fees_vat;
              case 'Refund':
                return refund;
              case 'Income' :
                return income;
              default:
                return data;
            }
          }
        },
        {'data': 'clientName'},
        {'data': 'clientMobile'},
        {'data': 'date'}
      ],
      'order': [[4, 'desc']],
    });

    $('#withdraws-extension').DataTable({
      dom: '<"row"<"col-md-12"<"row"<"col-md-6"B><"col-md-6"f> > ><"col-md-12"rt> <"col-md-12"<"row"<"col-md-5"i><"col-md-7"p>>> >',
      buttons: {
        buttons: [
          {extend: 'copy', className: 'btn', text: await lastValueFrom(this.translate.get('Copy'))},
          {extend: 'excel', className: 'btn', text: await lastValueFrom(this.translate.get('Excel'))},
          {extend: 'print', className: 'btn', text: await lastValueFrom(this.translate.get('Print'))}
        ]
      },
      'oLanguage': {
        'oPaginate': {
          'sPrevious': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>',
          'sNext': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>'
        },
        'sInfo': await lastValueFrom(this.translate.get('Showing page')) + ' _PAGE_ ' + await lastValueFrom(this.translate.get('of')) + ' _PAGES_',
        'sSearch': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>',
        'sSearchPlaceholder': await lastValueFrom(this.translate.get('Search')) + ' ...',
        'sLengthMenu': 'Results :  _MENU_',
      },
      'stripeClasses': [],
      'lengthMenu': [7, 10, 20, 50],
      'pageLength': 7,
      'data': this.withdraws,
      'order': [[5, 'desc']],
      'columns': [
        {'data': 'bankName'},
        {'data': 'lastIban'},
        {
          'data': 'amount', 'render': (data) => {
            return this._decimalPipe.transform(data, '1.2-2') + ' ' + sar;
          }
        },
        {
          'data': 'fees', 'render': (data) => {
            return this._decimalPipe.transform(data, '1.2-2') + ' ' + sar;
          }
        },
        {
          'data': 'identityNumber', 'render': (data, type, object) => {
            if (object.amount <= 0) {
              return '<span class="text-danger">' + data + '</span>';
            } else {
              return '<span class="text-success">' + data + '</span>';
            }
          }
        },
        {'data': 'date'},
        {
          'data': 'isTransferred', 'render': (data, type, object) => {
            if (object.amount <= 0) {
              return '<span class="text-danger">' + cancelled + '</span>';
            } else {
              return data ? '<span class="text-success">' + yes + '</span>' : '<span class="text-danger">' + no + '</span>';
            }
          }
        },
        {'data': 'receiverName'},
      ]
    });
  }

  private async downloadVatPdf() {
    $(this.pdfDownloadModal.nativeElement).modal('show');
  }

  private async downloadExcelReport() {
    $(this.excelDownloadModal.nativeElement).modal('show');
  }

  private async loadResources() {
    await this.loader.loadExternalStyles('/assets/css/components/tabs-accordian/custom-tabs.css');
    await this.loader.loadExternalStyles('https://cdn.datatables.net/1.12.1/css/jquery.dataTables.css');
    await this.loader.loadExternalStyles('/plugins/table/datatable/dt-global_style.css');
    await this.loader.loadExternalStyles('/plugins/table/datatable/custom_dt_html5.css');

    await this.loader.loadExternalScript('https://cdn.datatables.net/1.12.1/js/jquery.dataTables.js');
    await this.loader.loadExternalScript('/plugins/table/datatable/button-ext/dataTables.buttons.min.js');
    await this.loader.loadExternalScript('/plugins/table/datatable/button-ext/jszip.min.js');
    await this.loader.loadExternalScript('/plugins/table/datatable/button-ext/buttons.html5.min.js');
    await this.loader.loadExternalScript('/plugins/table/datatable/button-ext/buttons.print.min.js');
    await this.loader.loadExternalScript('plugins/apex/apexcharts.min.js');
    await this.loader.loadExternalScript('/plugins/notification/snackbar/snackbar.min.js');
  }

  private async loadSalesChart() {

    let dailySales: any = await this.api.getMyDailySales();

    let labels = dailySales.labels;
    let totalSales = dailySales.totalSales;
    let totalExpenses = dailySales.totalExpenses;

    let chartData = {
      chart: {
        fontFamily: 'Nunito, sans-serif',
        height: 365,
        type: 'area',
        zoom: {
          enabled: false
        },
        dropShadow: {
          enabled: true,
          opacity: 0.3,
          blur: 5,
          left: -7,
          top: 22
        },
        toolbar: {
          show: false
        },
        events: {
          mounted: (ctx) => {
            const highest1 = ctx.getHighestValueInSeries(0);
            const highest2 = ctx.getHighestValueInSeries(1);

            ctx.addPointAnnotation({
              x: new Date(ctx.w.globals.seriesX[0][ctx.w.globals.series[0].indexOf(highest1)]).getTime(),
              y: highest1,
              label: {
                style: {
                  cssClass: 'd-none'
                }
              },
              customSVG: {
                SVG: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="#1b55e2" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-circle"><circle cx="12" cy="12" r="10"></circle></svg>',
                cssClass: undefined,
                offsetX: -8,
                offsetY: 5
              }
            });
            ctx.addPointAnnotation({
              x: new Date(ctx.w.globals.seriesX[1][ctx.w.globals.series[1].indexOf(highest2)]).getTime(),
              y: highest2,
              label: {
                style: {
                  cssClass: 'd-none'
                }
              },
              customSVG: {
                SVG: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="#e7515a" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-circle"><circle cx="12" cy="12" r="10"></circle></svg>',
                cssClass: undefined,
                offsetX: -8,
                offsetY: 5
              }
            });
          },
        }
      },
      colors: ['#3087DE', '#8C60E2'],
      dataLabels: {
        enabled: false
      },
      markers: {
        discrete: [{
          seriesIndex: 0,
          dataPointIndex: 7,
          fillColor: '#000',
          strokeColor: '#000',
          size: 5
        }, {
          seriesIndex: 2,
          dataPointIndex: 11,
          fillColor: '#000',
          strokeColor: '#000',
          size: 4
        }]
      },
      // subtitle: {
      //   text: await this.translate.get('Total Sales').toPromise(),
      //   align: 'right',
      //   margin: 0,
      //   offsetX: -70,
      //   offsetY: 35,
      //   floating: false,
      //   style: {
      //     fontSize: '14px',
      //     color: '#888ea8'
      //   }
      // },
      title: {
        text: '-',
        align: 'left',
        margin: 0,
        offsetX: -90,
        offsetY: 0,
        floating: false,
        style: {
          fontSize: '25px',
          color: '#0e1726'
        },
      },
      stroke: {
        show: true,
        curve: 'smooth',
        width: 2,
        lineCap: 'square'
      },
      series: [{
        name: 'المبيعات',
        // data: [16800, 16800, 15500, 17800, 15500, 17000, 19000, 16000, 15000, 17000, 14000, 17000].reverse()
        data: totalSales.reverse()
      }, {
        name: 'رسوم بيلينك',
        // data: [16500, 17500, 16200, 17300, 16000, 19500, 16000, 17000, 16000, 19000, 18000, 19000].reverse()
        data: totalExpenses.reverse()
      }],
      // labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].reverse(),
      labels: labels.reverse(),
      xaxis: {
        axisBorder: {
          show: true
        },
        axisTicks: {
          show: true
        },
        crosshairs: {
          show: true
        },
        labels: {
          offsetX: 0,
          offsetY: 5,
          style: {
            fontSize: '12px',
            fontFamily: 'Nunito, sans-serif',
            cssClass: 'apexcharts-xaxis-title',
          },
        }
      },
      yaxis: {
        labels: {
          formatter: function(value) {
            // return (value / 1000) + 'K'
            return value;
          },
          offsetX: -25,
          offsetY: 0,
          style: {
            fontSize: '12px',
            fontFamily: 'Nunito, sans-serif',
            cssClass: 'apexcharts-yaxis-title',
          },
        }
      },
      grid: {
        borderColor: '#e0e6ed',
        strokeDashArray: 5,
        xaxis: {
          lines: {
            show: true
          }
        },
        yaxis: {
          lines: {
            show: false,
          }
        }
      },
      legend: {
        position: 'top',
        horizontalAlign: 'right',
        offsetY: -50,
        fontSize: '16px',
        fontFamily: 'Nunito, sans-serif',
        markers: {
          width: 10,
          height: 10,
          strokeWidth: 0,
          strokeColor: '#fff',
          fillColors: undefined,
          radius: 12,
          onClick: undefined,
          offsetX: 0,
          offsetY: 0
        },
        itemMargin: {
          horizontal: 0,
          vertical: 20
        }
      },
      tooltip: {
        theme: 'dark',
        marker: {
          show: true,
        },
        x: {
          show: false,
        }
      },
      fill: {
        type: 'gradient',
        gradient: {
          type: 'vertical',
          shadeIntensity: 1,
          inverseColors: !1,
          opacityFrom: .28,
          opacityTo: .05,
          stops: [45, 100]
        }
      },
      responsive: [{
        breakpoint: 575,
        options: {
          legend: {
            offsetY: -30,
          },
        },
      }]
    };
    let salesChart = new ApexCharts(
      document.querySelector('#revenueMonthly'),
      chartData
    );
    salesChart.render();
  }

}
